/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceGeneratePackageInvoiceRequest
 */
export interface InvoiceGeneratePackageInvoiceRequest {
    /**
     * 
     * @type {string}
     * @memberof InvoiceGeneratePackageInvoiceRequest
     */
    packageIds: string;
}

/**
 * Check if a given object implements the InvoiceGeneratePackageInvoiceRequest interface.
 */
export function instanceOfInvoiceGeneratePackageInvoiceRequest(value: object): value is InvoiceGeneratePackageInvoiceRequest {
    if (!('packageIds' in value) || value['packageIds'] === undefined) return false;
    return true;
}

export function InvoiceGeneratePackageInvoiceRequestFromJSON(json: any): InvoiceGeneratePackageInvoiceRequest {
    return InvoiceGeneratePackageInvoiceRequestFromJSONTyped(json, false);
}

export function InvoiceGeneratePackageInvoiceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceGeneratePackageInvoiceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'packageIds': json['packageIds'],
    };
}

export function InvoiceGeneratePackageInvoiceRequestToJSON(json: any): InvoiceGeneratePackageInvoiceRequest {
    return InvoiceGeneratePackageInvoiceRequestToJSONTyped(json, false);
}

export function InvoiceGeneratePackageInvoiceRequestToJSONTyped(value?: InvoiceGeneratePackageInvoiceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'packageIds': value['packageIds'],
    };
}

